<!--
    我的课程-课程详情-头部组件
    功能：头部组件内容
    说明：版本3.0
-->
<template>
  <div class="detail-top">
    <img
      :src="detail.cover ? detail.cover : $assets.classDefault"
      :alt="detail.name"
      class="left-img"
    >
    <div class="right-cont">
      <div class="title">{{ detail.name }}</div>
      <div class="cont">
        <div class="row">
          <div class="item">
            <span class="label">制作方：</span
            >{{ detail.company_name }}
          </div>
          <div class="item">
            <span class="label">上线时间：</span>{{ detail.created_at }}
          </div>
          <div class="item">
            <span class="label">课时数量：</span>{{ detail.detail_count }}课时
          </div>
        </div>
        <div class="row">
          <div
            v-if="detail.auth_expire_time"
            class="item">
            <span class="label">截止有效期：</span
            ><span class="price">{{ detail.auth_expire_time }}</span>
          </div>
          <div
            v-if="detail.auth_number"
            class="item">
            <span class="label">剩余次数：</span
            ><span class="price">{{ detail.auth_number - detail.used_number }}次</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DetailTop',
  props: {
    detail: Object,
  },
  created() {
  },
  data() {
    return {
    };
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.detail-top {
  display: flex;
  .left-img {
    width: 172px;
    height: 192px;
    border-radius: 4px;
    background: #ffd284;
    // box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    border: 1px solid #ecedee;
    object-fit: cover;
  }
  .right-cont {
    margin-left: 20px;
    flex: 1;
    .title {
      font-size: 18px;
      color: #303133;
      padding: 30px 0 18px 0;
      font-weight: 600;
    }
    .cont {
      width: 100%;
      box-sizing: border-box;
      padding: 0 20px;
      background: rgba(245, 245, 245, 0.5);
      border-radius: 2px;
      color: #333;
      font-size: 14px;
      height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .row {
        width: 100%;
        padding: 5px 0;
      }
      .item {
        display: inline-block;
        margin-right: 20px;
      }
      .label {
        color: #868796;
      }
      .price {
        color: #ff3622;
      }
      .font {
        font-size: 20px;
      }
      .default-price {
        text-decoration: line-through;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageDetail/components/detailTop.vue